import React from "react";

export default function ProficiencyLevels_UZ() {
  return (
    <>
      <h2>Malaka darajalarini tushuntirish</h2>
      <div>
        Shaxsiy kompetensiyangiz profilini yaxshiroq tushunish uchun siz o'z faoliyatingizni sohalar
        bo'yicha ko'rib chiqishingiz kerak. Bu sizga kuchli va zaif tomonlaringizni aniqlashga yordam
        beradigan ilk g'oyani, shuningdek, raqamli amaliyotingizni yanada rivojlantirish bo'yicha
        maslahatlarni beradi.
        <ul>
          <li>A1: 32/192 ballgacha, 17% gacha</li>
          <li>A2: 33-64/192 ballgacha, 18-33%</li>
          <li>B1: 65-96/192 ballgach, 34-50%</li>
          <li>B2: 97-128/192 ballgach, 51-67%</li>
          <li>C1: 129-160/192 ballgacha, 68-83%</li>
          <li>C2: 161-192/192 ballgacha, 84-100%</li>
          <li>D1: 0/192 ballgacha, 0%</li>
        </ul>
      </div>
      <div>
        <h3>Boshlovchi (A1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Raqamli texnologiyalar sizning professional amaliyotingizni qanday qo'llab-quvvatlashi va
          yaxshilashi mumkinligidan xabardorsiz. Ushbu o'z-o'zini baholashdan olgan fikr-mulohazalaringiz
          siz sinab ko'rishingiz mumkin bo'lgan bir qator faoliyat yo’nalishlarini ko’rsatib berdi.
          Ta'lim strategiyalaringizni maqsadli amalga oshirishga e'tibor qaratib, kasbiy
          rivojlanishingizning keyingi bosqichini rejalashtirish uchun bir yoki ikkita faoliyat
          yo’nalishlarini tanlang. Shunday qilib, siz raqamli kompetensiyaning keyingi bosqichiga,
          Izlanuvchi darajasi tomon ildamlab borasiz.
        </div>
      </div>
      <div>
        <h3>Izlanuvchi (A2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Siz raqamli texnologiyalarning imkoniyatlarini o'rganishni boshladingiz va o'qitish va kasbiy
          amaliyotingizni yaxshilash uchun ulardan foydalanishga qiziqasiz. Siz baʼzi sohalarda raqamli
          texnologiyalardan foydalanishga urinib koʻrdingiz va yanada izchil foydalanishdan
          manfaatlanasiz. Raqamli texnologiyalardan turli kontekstlarda va turli maqsadlarda foydalanish,
          ularni amaliyotga tadbiq qilish orqali o'z malakangizni oshirishingiz mumkin. Bu harakatlar
          sizni raqamli kompetensiyaning keyingi bosqichiga, ya'ni Integrator darajasiga ko’taradi.
        </div>
      </div>
      <div>
        <h3>Integrator (B1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Siz turli xil kontekstlarda va turli maqsadlarda raqamli texnologiyalar bilan tajriba
          o'tkazasiz, ularni amaliyotga qollaysiz. Siz o'z professional faoliyatingizning turli
          jihatlarini yaxshilash uchun ulardan ijodiy foydalanasiz. Tajribangizni kengaytirishga harakat
          qilasiz. Qaysi vaziyatlarda qaysi vositalar eng yaxshi ishlashi va raqamli texnologiyalarni
          pedagogik strategiya va usullarga moslashtirish bo’yicha malakangizni oshirib borish orqali
          manfaat topasiz. Keyingi mutaxassis bosqichga o'tish uchun fikr-mulohaza qilish va
          moslashishga, hamkorliknni qo'llab-quvvatlash va tajriba almashishga ko'proq vaqt ajratishga
          harakat qiling.
        </div>
      </div>
      <div>
        <h3>Mutaxassis (B2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Siz professional faoliyatingizni oshirish uchun bir qator raqamli texnologiyalardan ishonchli,
          ijodiy va tanqidiy foydalanasiz. Siz aniq vaziyatlar uchun raqamli texnologiyalarni maqsadli
          tanlaysiz va turli raqamli strategiyalarning afzalliklari va kamchiliklarini tushunishga
          harakat qilasiz. Siz hali sinab ko'rmagan ko'p narsalar borligini anglagan holda, yangi
          g'oyalarga qiziqasiz va ularni sinab ko’rishga intilasiz. Siz tajriba va mulohazalardan
          o’qitish va o’rganish strategiyalaringizni qayta ishlab chiqish, kengaytirish, tizimli ishlab
          chiqish va mustahkamlash vositasi sifatida foydalanasiz. Tajribangizni boshqa o'qituvchilar
          bilan baham ko'ring va yo’lboshchi darajasiga erishish uchun raqamli strategiyalaringizni
          tanqidiy rivojlantirishda davom eting.
        </div>
      </div>
      <div>
        <h3>Yo’lboshchi (C1)</h3>
        <div style={{ marginBottom: "20px" }}>
          Siz pedagogik va professional tajribani oshirish uchun raqamli texnologiyalardan foydalanishga
          izchil va har tomonlama yondashasiz. Siz raqamli strategiyalarning keng doirasiga tayangan
          holda, istalgan vaziyatda texnologiyalarning eng mosini tanlashni bilasiz. Siz doimo o'z
          tajribangiz haqida fikr yuritasiz va uni takomillashtirasiz. Tengdoshlar bilan muloqot orqali
          siz yangi ishlanmalar va g'oyalardan xabardor bo'lasiz va boshqa o'qituvchilarga o'qitish va
          o'rganishni yaxshilash uchun raqamli texnologiyalarning imkoniyatlaridan foydalanishga yordam
          berasiz. Agar siz maktab doirasida va undan tashqarida, talabalarning raqamli salohiyatlarini
          kengaytirish imkoniyatlariga ularni jalb qilish orqali ko'proq tajriba o'tkazishga tayyor
          bo'lsangiz, eng yuqori malaka darajasiga erishishingiz mumkin.
        </div>
      </div>
      <div>
        <h3>Novator (C2)</h3>
        <div style={{ marginBottom: "20px" }}>
          Siz yo’lboshchi bo'lgan zamonaviy raqamli va pedagogik amaliyotlarning yetarliligi haqida
          tanqidiy fikr yuritasiz. Siz ushbu amaliyotlarning cheklovlari yoki kamchiliklari haqida
          qayg'urasiz va ta'lim natijalarini yanada yaxshilash ustida ishlaysiz. Siz innovatsion va
          murakkab raqamli texnologiyalar bilan tajriba o'tkazasiz va yangi pedagogik yondashuvlarni
          ishlab chiqasiz. Siz maktabingizda yangilik kiritish jarayonini boshqarasiz va boshqa
          o'qituvchilar uchun namuna ko’rsatasiz. Siz o'z tajribangizni maktab hamjamiyatidan tashqarida
          ham tadbiq etasiz va rivojlanishdan manfaatdor tomonlarni jalb qilasiz. Yangi ta’lim
          texnologiyalarini o’rganish, tadbiq etish, hamda ijodiy va innovatsion yechimlaringizni
          yaxshilash uchun texnologik va pedagogik yutuqlardan xabardor bo’lishda davom eting.
        </div>
      </div>
      <div>
        <h3>Raqamli kompetensiyasizlik (D1) </h3>
        <div style={{ marginBottom: "20px" }}>
          Siz hozir ta'limdagi raqamli sayohatning boshida turibsiz. Ehtimol, raqamli vositalar va
          texnologiyalarning ulkan dunyosi sizga notanish va biroz g'alati tuyuladi. Siz hali mavjud
          raqamli o'qitish strategiyalarini o'rganmagan yoki foydalanmagan bo'lsangiz ham, sizda qiziqish
          va ularni o'rganish istagi bor. Ushbu sayohatni boshlaganingizda, har bir kishi bir joydan
          boshlashi zarurliginin unutmang. Zarur manbalar va qo'llab-quvvatlash natijasida siz tez orada
          o'z tayanchingizni topasiz va raqamli integratsiya yordamida ta’lim berishni yaxshilashda
          cheksiz imkoniyatlarni kashf etasiz.
        </div>
      </div>
    </>
  );
}
